import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Backdrop, Box, Modal, Fade, Typography, Slider, Grid, Button } from '@material-ui/core/'
import { ClosePodcastModalIcon } from '../../../assetss/img/index'
import c from 'classnames'
import api from '../../../api/stoty'
import ButtonSlide from './components/ButtonSlide'
import ButtonSlideMobile from './components/ButtonSlideMobile'
import { emotionsBtn } from './components/constants'
import './index.scss'

const ModalPodcast = ({ isOpen, setOpen, idPodcast }) => {
  const [valueSlider, setValueSlide] = useState(100)
  const [reactionId, setReactionId] = useState(null)
  const [dataStatistick, setDataStatistick] = useState({})
  const handleClose = () => {
    setOpen(false)

    setTimeout(() => {
      setValueSlide(100)
      setActiveSlide(false)
    }, 1000)
  }
  const [activeSlide, setActiveSlide] = useState(false)
  const { user } = useSelector(({ session }) => session)

  const onChangeValue = step => setValueSlide(step)

  const onChange = (_, v) => setValueSlide(v)

  const getStatistick = () => {
    api.getReactionStatistic(idPodcast, user?.accessKey)
      .then(res => {
        setDataStatistick(res?.data)
        setActiveSlide(prev => !prev)
      })
      .catch(error => console.error(error))
  }

  const sendReactions = () => {
    api.sendReactionPodcast(idPodcast, { accessKey: user?.accessKey, feedback: reactionId })
      .then(res => {
        setDataStatistick(res?.data)
        getStatistick()
      })
      .catch(error => console.error(error))
  }

  const onSubmit = () => sendReactions()

  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      step={0.01}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Box className='modalPodcastWrapper'>
          <Grid className='closeModalIcon' onClick={handleClose}>
            <ClosePodcastModalIcon />
          </Grid>
          <Typography className='titleModal' id='transition-modal-title' variant='h6' component='h2'>
            How was the podcast that you just listened to?
          </Typography>

          <Typography className={c('descModal', activeSlide && 'descModalMobile', !activeSlide && 'descModal', !activeSlide && 'descModalSecondTitle')} id='transition-modal-description'>
            See how others repsonded along with their stories.
          </Typography>
          <Typography className={c(activeSlide && 'descModal', !activeSlide && 'descModalMobile', 'descModal')} id='transition-modal-description'>
            Drag to choose the adjective that best describes the way you feel after listening to the podcast. See how others repsonded along with their stories.
          </Typography>
          <Grid className={c('sliderBoxModal', activeSlide && 'sliderBoxModalActive', activeSlide && 'sliderBoxModalMobile')}>
            <Slider
              className={c('modalSlider', activeSlide && 'modalSliderDisabled')}
              style={{ height: 305 }}
              defaultValue={100}
              aria-labelledby='vertical-slider'
              orientation='vertical'
              track='inverted'
              // step={0.01}
              value={valueSlider}
              onChange={onChange}
            />
            <Grid className={c('groupBtnSlide', activeSlide && 'groupBtnSlideActive')}>
              {emotionsBtn?.map(({ title, marginTop, step, type, feedback, path }) => (
                <ButtonSlide
                  setValueSlide={setValueSlide}
                  feedback={feedback}
                  dataStatistick={dataStatistick}
                  type={type}
                  key={title}
                  title={title}
                  marginTop={marginTop}
                  value={valueSlider}
                  step={step}
                  onChangeValue={onChangeValue}
                  onSubmit={onSubmit}
                  activeSlide={activeSlide}
                  isOpen={isOpen}
                  setReactionId={setReactionId}
                  path={path}
                  idPodcast={idPodcast}
                />
              ))}
              {emotionsBtn?.map(({ title, marginTop, step, type, feedback, path }) => (
                <ButtonSlideMobile
                  idPodcast={idPodcast}
                  setValueSlide={setValueSlide}
                  feedback={feedback}
                  dataStatistick={dataStatistick}
                  type={type}
                  key={title}
                  title={title}
                  marginTop={marginTop}
                  value={valueSlider}
                  step={step}
                  onChangeValue={onChangeValue}
                  onSubmit={onSubmit}
                  activeSlide={activeSlide}
                  isOpen={isOpen}
                  setReactionId={setReactionId}
                  path={path}
                />
              ))}
            </Grid>
          </Grid>

          {activeSlide ? (
            <Button
              className='generalButtonPodcastActive'
              onClick={handleClose}
              variant='outlined'
              color='primary'
            >
              Close
            </Button>
          ) : (
            <Button
              className='generalButtonPodcast'
              onClick={onSubmit}
              disabled={!reactionId}
              variant='outlined'
              color='primary'
            >
              Submit
            </Button>
          )}
        </Box>
      </Fade>
    </Modal>
  )
}

export default ModalPodcast
